const FACILITIES = [
  { name: "Swimming Pool", desc: "Freshwater recovery pool with sun lounger deck" },
  { name: "Rooftop Café", desc: "Elevated ocean views, espresso, fresh juices & meals" },
  { name: "Beachside Restaurant", desc: "Indonesian specialties, fresh fish, pasta and salads" },
  { name: "Mini Gym & Training", desc: "Weights, kettlebells, and mobility mats" },
  { name: "Games Lounge", desc: "Pool table & ping pong for post-surf chillouts" },
  { name: "Kids Playground", desc: "Safe play space for visiting surfing families" },
  { name: "Scooter Rental & Laundry", desc: "Explore South Nias bays with board-rack scooters" },
  { name: "Fast WiFi & Hot Showers", desc: "Reliable connectivity for work and steaming showers" },
];

const Facilities = () => (
  <section id="hotel-facilities" className="py-24 bg-sand-100 border-y border-sand-200" data-testid="facilities-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16">
        <div>
          <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
            Resort Amenities
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-ocean-900 mt-2">
            Built for surf recovery & remote work
          </h2>
        </div>
        <p className="text-xs font-mono-clean text-fog mt-2 md:mt-0">
          All facilities on-site & complimentary for guests
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
        {FACILITIES.map((f) => (
          <div key={f.name} className="bg-sand-50 p-6 rounded-2xl border border-sand-200">
            <h4 className="font-display font-bold text-ocean-900">{f.name}</h4>
            <p className="text-xs text-fog mt-1">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Facilities;
